export default "__VITE_ASSET__BWtK37gt__"